import angular from 'angular';
import { LoadParams } from '../../../../shared/models/loadparams.model';
import { ICalendarioFerias } from './models/calendarioferias.model';

export class MeurhCalendarioFeriasService {
	static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

	public entity: ICalendarioFerias;
	public entities: Array<ICalendarioFerias> = [];
	public loaded: boolean = false;
	public constructors: any = {};
	public after: any = {};
	public filters: any = {};
	public loadParams: LoadParams;
	public loading_deferred: any = null;
	public filter: any = '';

	constructor(
		public $http: angular.IHttpService,
		public nsjRouting: any,
		public $rootScope: angular.IRootScopeService,
		public $q: angular.IQService,
	) {
		this.loadParams = new LoadParams();
	}

	reload(): Array<ICalendarioFerias> {
		if (this.loading_deferred) {
			this.loading_deferred.resolve();
		}

		this.loadParams.finished = false;
		this.loadParams.to_load = 3;
		this.after = {};
		this.loaded = false;
		this.entities.length = 0;
		this.loadParams.busy = false;

		return this.load();
	}

	search(filter: any): Array<ICalendarioFerias> {
		if (typeof filter !== 'undefined') {
			this.filter = filter.search;
			Object.keys(this.filters).forEach((k: any) => { delete this.filters[k]; });

			for (var fil in filter.filters) {
				if (fil.indexOf('.') > -1) {
					var filterSplit = fil.split('.');
					this.filters[filterSplit[0]] = {};
					this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
				} else {
					this.filters[fil] = filter.filters[fil];
				}
			}
		}

		return this.reload();
	}

	_load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'GET',
				url: this.nsjRouting.generate('meurh_solicitacoesferias_calendario', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				resolve(response.data);
			})
			.catch((response: any) => {
				reject(response);
			});
		});
	}

	load(): Array<ICalendarioFerias> {
		if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
			this.loadParams.busy = true;

			this._load(this.constructors, this.after, this.filter)
				.then((data: any): void => {
					if (data.length > 0) {
						for (var i = 0; i < data.length; i++) {
							this.entities.push(data[i]);
						}
					}

					this.loadParams.finished = true;
					this.$rootScope.$broadcast('meurh_solicitacoesferias_calendario_list_finished', this.entities);

					this.loaded = true;
					this.loadParams.to_load--;
				})
				.catch((error: any): void => {
					if (error.xhrStatus !== 'abort') {
						this.loadParams.finished = true;
					}
				})
				.finally((): void => {
					if (this.loaded || this.loadParams.finished) {
						this.loadParams.busy = false;
					}

					this.load();
				});
		}

		return this.entities;
	}

	loadMore(): void {
		this.loadParams.to_load = 3;
		this.load();
	}
}
